import {
  HTTPQuery,
  TraderAndDonor,
  TraderAndDonorSearchRequest,
  TraderAndDonorFromJSON,
  TraderAndDonorSearchRequestToJSON,
  TraderAndDonorCreateRequest,
  TraderAndDonorCreateRequestToJSON,
  TraderAndDonorUpdateRequestToJSON,
  TraderAndDonorUpdateRequest
} from '@/api'
import * as runtime from '../runtime'

export class TraderAndDonorApi extends runtime.BaseAPI {
  /**
   * 業者・利用者取得
   */
  async getByCode(
    request: TraderAndDonorSearchRequest
  ): Promise<TraderAndDonor> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(TraderAndDonorSearchRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet('/trader-and-donor', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      TraderAndDonorFromJSON(jsonValue)
    ).value()
  }

  /**
   * 業者・利用者登録
   */
  async create(request: TraderAndDonorCreateRequest) {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(TraderAndDonorCreateRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestPost(
      '/trader-and-donor',
      queryParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 業者・利用者更新
   */
  async update(request: TraderAndDonorUpdateRequest) {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(TraderAndDonorUpdateRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestPut('/trader-and-donor', queryParameters)

    return new runtime.VoidApiResponse(response)
  }
}
